
export const apiUrl = process.env.REACT_APP_API_URL ;
export const imageDir = process.env.REACT_APP_IMAGE_DIR ;

